import React from "react";
import "./IssueListItem.css";
import blankCover from "../../assets/blankCover.jpg";
import Card from "react-bootstrap/Card";
import Image from "react-bootstrap/Image";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Badge from "react-bootstrap/Badge";
import { Link, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { loadAnIssueProdRequestAction } from "../../redux/actions/appIssueProdData";
import Moment from "moment";
import { toast } from "react-toastify";

class IssueListItem extends React.Component {
  constructor(props) {
    super(props);

    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
    this.handleDelete = this.handleDelete.bind(this);

    this.state = {
      isHovering: false
    };
  }

  handleMouseEnter() {
    this.setState({ isHovering: true });
  }

  handleMouseLeave() {
    this.setState({ isHovering: false });
  }

  handleDelete() {
    const { issue, handleDelete } = this.props;

    const isProcessing = issue.is_processing;

    if (isProcessing) {
      toast.error("Cannot delete processing issue");
      return;
    }

    handleDelete(issue);
  }

  componentDidMount() {
    const { prodData, loadAnIssueProdRequestAction, issue } = this.props;

    if (prodData == null && issue.production_bid != null) {
      loadAnIssueProdRequestAction(issue.id);
    }
  }

  render() {
    const { issue, match, currentIssueID, prodData } = this.props;

    const img =
      issue.cover.id == null
        ? blankCover
        : `${process.env.REACT_APP_API_ROOT}artworks/${
            issue.cover.id
          }/static/thumbnail`;

    let showBadge = false;
    let isCurIssue = false;

    const isPublishing = issue.is_publishing;
    const isProcessing = issue.is_processing;

    if (
      !isPublishing &&
      issue.production_bid != null &&
      currentIssueID != null
    ) {
      showBadge = true;
      isCurIssue = issue.production_bid === currentIssueID;
    }

    const showProdData = prodData != null;

    let publishedTime = "";
    let offTime = "";

    if (showProdData) {
      publishedTime = Moment(prodData.published_date * 1000).format(
        "YYYY/M/D HH:mm:ss"
      );

      if (
        prodData.off_shelf_at !== null &&
        prodData.off_shelf_at !== 2147483647
      ) {
        offTime = Moment(prodData.off_shelf_at * 1000).format(
          "YYYY/M/D HH:mm:ss"
        );
      } else {
        offTime = "N/A";
      }
    }

    return (
      <Card
        className="issue_card"
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
      >
        <Card.Body>
          <button
            className={
              this.props.isAdmin && this.state.isHovering
                ? "delete_btn"
                : "hidden"
            }
            onClick={this.handleDelete}
          >
            <span className="fa fa-times" />
          </button>

          <Link to={isProcessing ? "#" : match.url + "/" + issue.id}>
            <Image src={img} className="issue_cover_image" />
          </Link>
        </Card.Body>
        <Card.Footer>
          <Container>
            <Row>
              <Col className="issue_name">{issue.issue}</Col>
            </Row>
            {showBadge && (
              <Row>
                <Col>
                  <Badge variant={isCurIssue ? "danger" : "info"}>
                    {isCurIssue ? "Current" : "Back"}
                  </Badge>
                </Col>
              </Row>
            )}
            {isPublishing && (
              <Row>
                <Col>
                  <Badge variant="warning">Publishing</Badge>
                </Col>
              </Row>
            )}
            {isProcessing && (
              <Row>
                <Col>
                  <Badge variant="warning">Processing</Badge>
                </Col>
              </Row>
            )}
            {showProdData && (
              <React.Fragment>
                <Row>
                  <Col className="issue_extra">
                    Publish time:
                    <br />
                    {publishedTime}
                  </Col>
                </Row>
                <Row>
                  <Col className="issue_extra">
                    Off time:
                    <br />
                    {offTime}
                  </Col>
                </Row>
              </React.Fragment>
            )}
          </Container>
        </Card.Footer>
      </Card>
    );
  }
}

const mapState = (state, ownProps) => {
  const { issue } = ownProps;
  const { appIssueProdData } = state;

  return {
    prodData: appIssueProdData[issue.production_bid]
  };
};

const mapDispatch = {
  loadAnIssueProdRequestAction
};

export default connect(
  mapState,
  mapDispatch
)(withRouter(IssueListItem));
